import * as yup from 'yup';
import { LessonPlanType } from '../../types/LessonPlan';

export const CreateLessonPlanFormValidation: yup.ObjectSchema<LessonPlanType> = yup.object({
    idSubject: yup.string().required('Disciplina é obrigatória'),
    subject: yup.string().optional(),
    idTeacher: yup.string().required('Docente é obrigatório'),
    teacher: yup.string().optional(),
    teacherCode: yup.string().optional(),
    dateDisplay: yup.string().optional(),
    class: yup.string().optional(),
    date: yup.string().required('Data é obrigatória').default(new Date().toISOString()),
    objectives: yup.string().required('Objectivo é obrigatório'),
    activities: yup.string().optional(),  
    resources: yup.string().required('Recurso é obrigatório'),
    status: yup.bool().required('obrigatório').default(true),
    id: yup.string().optional(),
    idSubjectPlan: yup.string().optional(),  
    idClass: yup.string().optional(),  
    description: yup.string().optional(),  
    level: yup.number().optional(),
    semester: yup.number().optional(),
    documents: yup.array().of(
        yup.object().shape({
            id: yup.string().optional(),
            idLessonPlan: yup.string().optional(),
            status: yup.bool().optional(),
            filename: yup.string().optional(),
            docBase64: yup.string().optional(),
            description: yup.string().optional(),
            file: yup.mixed<File>()
            .required('O ficheiro é obrigatório')
            .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File)
        })
    ).optional(),
});

